import {ActionCreator} from 'redux';
import {Dispatch, ThunkAction} from '../../../../../../../../types/actions';
import {IGetState} from '../../../../../../../../types/types';
import {LD_CARDS_LIMIT_DEFAULT} from '../../../../constants';
import {getLimitCardsNumber} from '../../../../../../../../store/model/list/selectors/getLimitCardsNumber';
import {onSaveLimit} from '../../LimitCardsNumberHOC/events/onSaveLimit';

export const toggleCardsNumber: ActionCreator<ThunkAction> = (
    listId: number
) => {
    const action = (
        dispatch: Dispatch,
        getState: IGetState
    ) => {
        const state = getState();
        const limit = getLimitCardsNumber(state, listId);
        const isOpened = !!limit;
        if (isOpened) {
            dispatch(onSaveLimit(listId, 0));
        } else {
            dispatch(onSaveLimit(listId, LD_CARDS_LIMIT_DEFAULT));
        }
    };
    return action;
};
